import { FETCH_ROLES, SET_ROLES } from "redux/constants/portal";

export const fetchRoles = (tenant_id) => ({
  type: FETCH_ROLES,
  payload: { tenant_id },
});

export const setRoles = (payload) => ({
  type: SET_ROLES,
  payload,
});
